export default function () {
  return [
    {
      type: 'DatePicker',
      title: '提交时间',
      [$field]: 'adviceTime',
      rules: [''],
      colSpan: 8,
      readOnly: true
    },
    {
      type: 'Input',
      title: '标题',
      [$field]: 'title',
      rules: ['required'],
      colSpan: 24,
      placeholder: '请输入'
    },
    {
      type: 'Checkbox',
      title: '心声建议类型',
      [$field]: 'typeCodes',
      colSpan: 8,
      optionList: this.getTypeCodesOptionList,
      rules: ['required']
    },
    {
      type: 'Input',
      title: '所属组织',
      [$field]: 'orgName',
      rules: ['required'],
      colSpan: 24,
      readOnly: true
    },
    {
      type: 'textarea',
      title: '心声建议说明',
      [$field]: 'adviceDesc',
      rules: ['required'],
      colSpan: 24,
      props: {
        rows: 8
      },
      placeholder: '请输入'
    }
  ]
}


export const attachmentOptions = function () {
  return [
    {
      type: 'FileUpload',
      title: '附件资料',
      colSpan: 24,
      [$field]: 'fileInfo',
      readOnly: false,
      props: {
        data: {
          groupId: this.groupId
        },
        multiple: true,
        getUploadFiles: this.getUploadFiles,
        isShowFileList: true
      },
      rules: ['']
    }
  ]
}